import { createContext } from 'react'
import { TypeContextTableData } from 'Type'

const ContextTableData = createContext<TypeContextTableData>({data: [], updates: {}, colors: {}, columns: {}})

export default ContextTableData